"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.67769 16C3.75351 16.0022 2.84949 15.73 2.08024 15.218C1.31099 14.706 0.711144 13.9771 0.35675 13.1239C0.00235613 12.2707 -0.0906283 11.3315 0.089585 10.4254C0.269798 9.51932 0.715094 8.68711 1.36902 8.03429L8.43569 0.980261C9.06116 0.353612 9.91004 0.00100195 10.7956 2.13201e-06C11.6811 -0.000997689 12.5308 0.349694 13.1577 0.97493C13.7846 1.60017 14.1373 2.44873 14.1383 3.33394C14.1393 4.21916 13.7885 5.06852 13.163 5.69517L6.09569 12.7485C5.71346 13.1127 5.2057 13.3158 4.67769 13.3158C4.14967 13.3158 3.64191 13.1127 3.25969 12.7485C3.07373 12.5629 2.92622 12.3424 2.82557 12.0997C2.72492 11.857 2.67311 11.5968 2.67311 11.3341C2.67311 11.0713 2.72492 10.8112 2.82557 10.5685C2.92622 10.3258 3.07373 10.1053 3.25969 9.91959L9.85569 3.33805L10.801 4.28103L4.20502 10.8639C4.08004 10.9889 4.00983 11.1584 4.00983 11.3351C4.00983 11.5118 4.08004 11.6812 4.20502 11.8062C4.33238 11.9277 4.50165 11.9955 4.67769 11.9955C4.85372 11.9955 5.023 11.9277 5.15035 11.8062L12.2224 4.75219C12.5976 4.37616 12.8081 3.86651 12.8075 3.33536C12.8069 2.8042 12.5952 2.29505 12.219 1.91991C11.8429 1.54477 11.333 1.33437 10.8017 1.33499C10.2703 1.33562 9.76097 1.54722 9.38569 1.92324L2.31435 8.97661C1.6888 9.60317 1.33785 10.4525 1.33873 11.3377C1.3396 12.2229 1.69223 13.0715 2.31902 13.6968C2.94582 14.3222 3.79544 14.673 4.68099 14.6721C5.56653 14.6712 6.41546 14.3187 7.04102 13.6922L15.055 5.69517L16.0004 6.63815L7.98635 14.6352C7.55184 15.0691 7.0359 15.4131 6.46812 15.6473C5.90035 15.8815 5.2919 16.0013 4.67769 16Z",
    fill: fill
  }));
};

exports["default"] = _default;